import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const passwordValidation = {
    mobile: {
        root: {
            position: "relative" as "relative",
            height: "0",
            overflow: "visible",
            zIndex: 500,
            fontFamily: Font.Poppins
        },
        panel: {
            position: "absolute" as "absolute",
            top: "1vw",
            left: "0",
            width: "100%",
            zIndex: 500,
            border: "1.5px solid " + Color.DarkAsh,
            borderRadius: "2.41vw",
            backgroundColor: Color.White,
            padding: "2.41vw 3.38vw",
            boxSizing: "border-box" as "border-box",
            boxShadow: "0 4px 16px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06)",
            transition: "border-color 0.2s ease",
            valid: {
                borderColor: Color.SharpGreen,
                backgroundColor: Color.SharpGreen
            }
        },
        panelHeader: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "2vw"
        },
        panelTitle: {
            fontSize: "3.14vw",
            fontWeight: "600",
            color: Color.DeepBlack,
            letterSpacing: "0.02em"
        },
        strengthBadge: {
            display: "inline-flex",
            alignItems: "center",
            fontSize: "2.41vw",
            fontWeight: "600",
            letterSpacing: "0.04em",
            textTransform: "uppercase" as "uppercase",
            padding: "0.5vw 2vw",
            borderRadius: "99px",
            Weak: { 
                background: Color.Linen,
                color: Color.DarkRed
            },
            Fair: { 
                background: Color.OldLace,  
                color: Color.HarvestGold
            },
            Good: { 
                background: Color.LightGreen, 
                color: Color.Green     
            },
            Strong: { 
                background: Color.SharpGreen, 
                color: Color.Munsell  
            }
        },
        meterTrack: {
            display: "flex",
            gap: "1vw",
            marginBottom: "2vw"
        },
        meterSegment: {
            flex: "1",
            height: "0.96vw",
            borderRadius: "99px",
            backgroundColor: Color.DarkAsh,
            Weak: { 
                backgroundColor: Color.Red           
            },
            Fair: { 
                backgroundColor: Color.HarvestGold   
            },
            Good: { 
                backgroundColor: Color.Green        
             },
            Strong: { 
                backgroundColor: Color.Munsell 
            }
        },
        rulesList: {
            listStyle: "none",
            margin: "0",
            padding: "0",
            display: "flex",
            flexDirection: "column" as "column",
            gap: "1.5vw"
        },
        ruleItem: {
            display: "flex",
            alignItems: "flex-start",
            gap: "1.8vw",
            fontSize: "3.14vw",
            lineHeight: "1.4",
            met: {
                color: Color.Munsell,
                fontWeight: "500"
            },
            unmet: {
                color: Color.SharpAsh
            }
        },
        ruleIcon: {
            flexShrink: "0",
            width: "3.38vw",
            height: "3.38vw",
            marginTop: "0.2vw"
        },
        subList: {
            listStyle: "none",
            margin: "1.2vw 0 0 6vw",
            padding: "0",
            display: "flex",
            flexDirection: "column" as "column",
            gap: "1.2vw"
        },
        subItem: {
            display: "flex",
            alignItems: "center",
            gap: "1.8vw",
            fontSize: "2.90vw",
            lineHeight: "1.4",
            met: {
                color: Color.Munsell,
                fontWeight: "500"
            },
            unmet: {
                color: Color.SharpAsh
            }
        },
        subIcon: {
            flexShrink: "0",
            width: "3vw",
            height: "3vw"
        }
    },
    desktop: {
        root: {
            fontFamily: Font.Poppins
        },
        panel: {
            top: "0.25vw",
            borderRadius: "0.52vw",
            padding: "0.62vw 0.83vw"
        },
        panelHeader: {
            marginBottom: "0.5vw"
        },
        panelTitle: {
            fontSize: "0.85vw"
        },
        strengthBadge: {
            fontSize: "0.52vw",
            padding: "0.1vw 0.52vw"
        },
        meterTrack: {
            gap: "0.2vw",
            marginBottom: "0.52vw"
        },
        meterSegment: {
            height: "0.22vw"
        },
        rulesList: {
            gap: "0.4vw"
        },
        ruleItem: {
            gap: "0.42vw",
            fontSize: "0.73vw"
        },
        ruleIcon: {
            width: "0.83vw",
            height: "0.83vw",
            marginTop: "0.05vw"
        },
        subList: {
            margin: "0.3vw 0 0 1.4vw",
            gap: "0.3vw"
        },
        subItem: {
            gap: "0.42vw",
            fontSize: "0.68vw"
        },
        subIcon: {
            width: "0.73vw",
            height: "0.73vw"
        }
    }
};